// src/app/core/guards/admin.guard.ts

import { inject } from '@angular/core';
import { CanActivateFn, CanMatchFn } from '@angular/router';
import { PermissionService } from '@core/services/permission.service';
import { guardWithProfile } from './guard.utils';

/** Gates the entire /admin section — any admin permission grants access. */
export const adminGuard: CanMatchFn = () => {
  const perm = inject(PermissionService);
  return guardWithProfile(() => perm.canAccessAdmin(), '/dashboard');
};

/** Gates /admin/permissions. */
export const adminPermissionsGuard: CanActivateFn = () => {
  const perm = inject(PermissionService);
  return guardWithProfile(() => perm.canManagePermissions(), '/admin');
};

/** Gates /admin/users. */
export const adminUsersGuard: CanActivateFn = () => {
  const perm = inject(PermissionService);
  return guardWithProfile(() => perm.canManageUsers(), '/admin');
};
